"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEventsBySearch = exports.getLineTournamentsBySearch = void 0;
const getLineTournamentsBySearch = ({ tournaments, searchText, events, }) => {
    return tournaments.filter((tournament) => {
        if (events.length) {
            return events.filter((event) => event.tournament.id === tournament.id)
                .length;
        }
        return (tournament.name.toUpperCase().indexOf(searchText.toUpperCase()) !== -1);
    });
};
exports.getLineTournamentsBySearch = getLineTournamentsBySearch;
const getEventsBySearch = ({ events, searchText, }) => events.filter((event) => event.competitors.some((competitor) => competitor.name.toUpperCase().indexOf(searchText.toUpperCase()) !== -1) && event);
exports.getEventsBySearch = getEventsBySearch;
//# sourceMappingURL=index.js.map